import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function milestonesReducer(state = initialState.mileStone, action) {
	switch (action.type) {
		case types.GET_MILESTONES: {
			let mileStone = [...action.response];
			return mileStone;
		}

		case types.ADD_TIMEPHASE_UNDER_MILESTONE: {
			if (action.responseObj.status == HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);

				let index = tempState.findIndex((a) => a.id == action.response.timePhaseTypeId);
				if (index != -1) {
					tempState[index].timePhases.push(action.response);
				} else {
					let newMilestoneObj = {id: action.response.timePhaseTypeId, timePhaseTypeName: null};
					newMilestoneObj.timePhases = [action.response];
					tempState.push(newMilestoneObj);
				}
				return tempState;
			}
			return state;
		}

		case types.UPDATE_TIMEPHASE_UNDER_MILESTONE: {
			if (action.responseObj.status == HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);
				console.log(tempState);

				// remove timephase form old milestone.
				let index = tempState.findIndex((a) => a.id == action.oldTimePhaseTypeId);
				if (index != -1) {
					tempState[index].timePhases = tempState[index].timePhases.filter((a) => a.id != action.response.id);
				}

				// add timephase to new milestone.
				index = tempState.findIndex((a) => a.id == action.response.timePhaseTypeId);
				if (index != -1) {
					tempState[index].timePhases.push(action.response);
				}
				return tempState;
			}
			return state;
		}
		case types.DELETE_TIMEPHASE_UNDER_MILESTONE: {
			if (action.timephase) {
				// get data
				let newState = _.cloneDeep(state);
				let index = newState.findIndex((a) => a.id == action.timePhaseTypeId);
				if (index != -1) {
					newState[index].timePhases = newState[index].timePhases.filter((a) => a.id != action.timephase.timephaseId);
				}
				return newState;
			}
			return state;
		}

		default:
			return state;
	}
}
